import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { pfCreditCardValidator } from '../../../shared/helpers/validators/credit-card/validators.credit-card';

import { ICreditCard } from './credit-card-form.interface';

@Component({
    selector: 'mlp-ng-credit-card-form',
    templateUrl: './credit-card-form.component.html',
    styleUrls: ['./credit-card-form.component.scss']
})

export class CreditCardFormSharedComponent {
    @Input() description = [
        'Please choose your payment method and add your card information.',
        'Playfinder accepts all major credit and debit cards'
    ];

    @Input() inputStyle = 'primary';
    @Input() path = '/assets/img/';

    @Output() add: EventEmitter<ICreditCard> = new EventEmitter<ICreditCard>();
    @Output() cancel = new EventEmitter();

    errors = {
        cc: [{ title: 'Wrong card number' }],
        expiry: [{ title: 'Wrong expiry date' }],
    };

    form: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            cc: ['', pfCreditCardValidator],
            name: [''],
            expiry: ['', Validators.pattern(/\d{2}\/\d{2}/)],
            security: [''],
            zip: [''],
            save: [true],
            default: [false]
        });
    }

    submitCard(): void {
        if (this.form.valid && this.form.value.cc && this.form.value.name && this.form.value.expiry && this.form.value.security) {
            this.add.emit(this.form.value);
        }
    }
}
